"use client";

import { useState, useEffect } from "react";
import { Info } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@workspace/ui/components";
import { Button } from "@workspace/ui/components";

const STORAGE_KEY = "training-overview-info-shown";

export function TrainingInfoDialog() {
  const [open, setOpen] = useState(true);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        className="max-w-[calc(100%-2.5rem)] md:max-w-[456px] p-5 md:p-6 gap-8 md:gap-10 rounded-3xl"
        showCloseButton={true}
      >
        {/* Visually hidden title for accessibility */}
        <DialogTitle className="sr-only">Training Information</DialogTitle>

        <div className="flex flex-col gap-4 md:gap-6 w-full">
          {/* Icon */}
          <div className="bg-[#fff3dc] border border-[#f5d3a5] flex flex-col items-center justify-center p-3 rounded-xl shadow-[3px_3px_0px_0px_#f5d3a5] w-fit">
            <Info className="size-6 text-d-black" />
          </div>

          {/* Content */}
          <div className="flex flex-col gap-4 md:gap-5 w-full">
            <div className="flex flex-col gap-1.5 md:gap-2 w-full">
              <h2 className="text-lg md:text-[22px] font-semibold leading-6 md:leading-7 text-d-black">
                Pay attention!
              </h2>
            </div>

            {/* Info box */}
            <div className="bg-[#d8f1f7] px-5 py-4 rounded-2xl w-full">
              <p className="text-sm md:text-base font-medium leading-5 md:leading-[22px] text-[#4f94ae]">
                Make sure your speakers or headphones are turned on. The avatar
                will start speaking as soon as you click &quot;Start.&quot;
              </p>
            </div>
          </div>
        </div>

        {/* Button */}
        <Button
          variant="d-primary"
          className="h-10 md:h-auto px-4 md:px-5 py-2.5 md:py-[13px] text-base md:text-lg w-full md:w-auto"
          onClick={() => setOpen(false)}
        >
          Got it, thanks
        </Button>
      </DialogContent>
    </Dialog>
  );
}
